/**
 * Brace matching — the primitive every macro and command stage depends on.
 *
 * Ported from latexConverter.ts:`extractBracedContent`.
 *
 * FIDELITY NOTE: the source counts every `{` and `}` byte and does **not** exempt
 * escaped braces (`\{`, `\}`) or braces inside \verb. A LaTeX body containing a literal
 * `\{` therefore unbalances the count and the extraction returns null or over-runs.
 * That behaviour is reproduced here deliberately — "fixing" it would change which
 * documents convert and how, which is a behavioural change, not a port.
 * See CLAUDE.md § 3 and the risk register in docs/spec/00-MASTER-SPEC.md.
 */

export interface BracedContent {
  content: string
  /** Index of the closing `}`. */
  endIndex: number
}

/**
 * Read a `{...}` group starting at `startIndex`.
 *
 * @returns the group's inner text and the index of its closing brace, or null when
 *   `startIndex` is not `{` or the group is never closed.
 */
export function extractBracedContent(text: string, startIndex: number): BracedContent | null {
  if (text[startIndex] !== '{') return null

  let depth = 0
  let i = startIndex

  while (i < text.length) {
    if (text[i] === '{') depth++
    else if (text[i] === '}') {
      depth--
      if (depth === 0) {
        return {
          content: text.substring(startIndex + 1, i),
          endIndex: i,
        }
      }
    }
    i++
  }
  return null
}
